import React from 'react';
import ReportSectionPage from '../../../common/components/reports/ReportSectionPage';

const EnrollmentsReport = () => {
  return <ReportSectionPage scope="org-admin" section="course-enrollments" title="Course Enrollments Report" />;
};

export default EnrollmentsReport;
